/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingProductPriceTiersInner } from './BillingProductPriceTiersInner';
import {
    BillingProductPriceTiersInnerFromJSON,
    BillingProductPriceTiersInnerFromJSONTyped,
    BillingProductPriceTiersInnerToJSON,
    BillingProductPriceTiersInnerToJSONTyped,
} from './BillingProductPriceTiersInner';
import type { BillingProduct } from './BillingProduct';
import {
    BillingProductFromJSON,
    BillingProductFromJSONTyped,
    BillingProductToJSON,
    BillingProductToJSONTyped,
} from './BillingProduct';

/**
 * 
 * @export
 * @interface BillingProductPrice
 */
export interface BillingProductPrice {
    /**
     * 
     * @type {number}
     * @memberof BillingProductPrice
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BillingProductPrice
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BillingProductPrice
     */
    interval: BillingProductPriceIntervalEnum | null;
    /**
     * 
     * @type {number}
     * @memberof BillingProductPrice
     */
    fixedPrice: number | null;
    /**
     * 
     * @type {Array<BillingProductPriceTiersInner>}
     * @memberof BillingProductPrice
     */
    tiers: Array<BillingProductPriceTiersInner> | null;
    /**
     * 
     * @type {BillingProduct}
     * @memberof BillingProductPrice
     */
    billingProduct?: BillingProduct;
}

/**
* @export
* @enum {string}
*/
export enum BillingProductPriceIntervalEnum {
    Annual = 'Annual',
    Monthly = 'Monthly'
}


/**
 * Check if a given object implements the BillingProductPrice interface.
 */
export function instanceOfBillingProductPrice(value: object): value is BillingProductPrice {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('fixedPrice' in value) || value['fixedPrice'] === undefined) return false;
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    return true;
}

export function BillingProductPriceFromJSON(json: any): BillingProductPrice {
    return BillingProductPriceFromJSONTyped(json, false);
}

export function BillingProductPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingProductPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'interval': json['interval'],
        'fixedPrice': json['fixedPrice'],
        'tiers': (json['tiers'] == null ? null : (json['tiers'] as Array<any>).map(BillingProductPriceTiersInnerFromJSON)),
        'billingProduct': json['billingProduct'] == null ? undefined : BillingProductFromJSON(json['billingProduct']),
    };
}

  export function BillingProductPriceToJSON(json: any): BillingProductPrice {
      return BillingProductPriceToJSONTyped(json, false);
  }

  export function BillingProductPriceToJSONTyped(value?: BillingProductPrice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'interval': value['interval'],
        'fixedPrice': value['fixedPrice'],
        'tiers': (value['tiers'] == null ? null : (value['tiers'] as Array<any>).map(BillingProductPriceTiersInnerToJSON)),
        'billingProduct': BillingProductToJSON(value['billingProduct']),
    };
}

